/** @file poseNode: one node's entity-relative position, world rotation and parent index from a PoseBuffer. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { POSE_LAYOUT as L } from '@zilo/pose3d-pose/layout/poseLayout';

/** What the viewport reads of a node: its position, its bone origin (the parent end), rotation; `hidden` from the flags. */
export type PoseNodeView = { pos: Vec3; origin: Vec3; q: Quat; parent: number; hidden: boolean };

/** The columns of node `index` (read through `POSE_LAYOUT`, never a hard-coded stride). */
export function poseNode(pose: PoseBuffer, index: number): PoseNodeView {
  const o = index * L.stride;
  const at = (c: number): number => pose[o + c] ?? 0;
  return {
    pos: [at(L.px), at(L.py), at(L.pz)], origin: [at(L.ox), at(L.oy), at(L.oz)], q: [at(L.qx), at(L.qy), at(L.qz), pose[o + L.qw] ?? 1],
    parent: pose[o + L.parentIndex] ?? -1, hidden: (at(L.flags) & 1) !== 0,
  };
}
